

import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { debug, debuglog } from 'util';

export default {
components: {
XHeader,
XInput,
Group,
Selector,
Picker,
PopupPicker,
XButton,
Alert
},
props: ["uploadUrl"],
data() {
return {
show_div1:1,
model:{m_token:this.$route.query.token},
number:"",
picavalue: "",
imgUrl: null,
isEnlargeImage: false,
imgIndex:1,
imgSize:0,
province:0,
city:0,
list: [],
show:true,
showA:true,
showB:true,
detailInfo:{},
content:'PopupPicker = TransferDom + Popup + PopupHeader + Picker',
title2: '<div class="weui-cell__hd" > <span data-v-91147f3a="" class="weui-label"><span class="dot" style="  margin-left: 5px;color:#f94549">*</span>所在地</span></div>',
list2: [],
value2: [],

number:"",



company:"",
documentTypeid:"",
address:"",
isCret:true,
image1:"",
image2:"",
image3:"",

fromUrl:this.$route.query.fromUrl
};
},
mounted(){
var radioS = document.getElementsByClassName("van-radio__label")

},

created () {
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getIsCert',this.model,{emulateJSON:true}).then(function(res){
if(res.body.cert==3){
this.show_div1=1;
}else if(res.body.cert==1){
this.show_div1=2;

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.company = res.body.company
this.image1 =res.body.businessLicensePic
this.image2 =res.body.businessEntityPicA
this.image3 =res.body.businessEntityPicB
this.documentTypeid = res.body.documentTypeid
this.address = res.body.address
},function(res){
console.log(res.status);
});
}

else if(res.body.cert==2){
this.show_div1=3;
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.model = res.body.company;
this.model.m_token = this.$route.query.token;
let str = res.body.company.registrationNumber
if(str.length>=6){
this.number = str.substring(0,3) + "****" + str.substring(str.length-3,str.length);
}else{
this.number = str.substring(0,2) + "****" + str.substring(str.length-2,str.length);
}
},function(res){
console.log(res.status);
});
}else if(res.body.cert==-1){
this.isCret=false;
this.show_div1=2;

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.image1 =res.body.businessLicensePic
this.image2 =res.body.businessEntityPicA
this.image3 =res.body.businessEntityPicB

this.company = res.body.company
this.documentTypeid = res.body.documentTypeid
this.address = res.body.address
},function(res){
console.log(res.status);
});
}else if(res.body.cert==0){
this.show_div1=1;

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.model = res.body.company;
this.model.registrationProvince = res.body.company.registrationProvince;
this.model.registrationCity = res.body.company.registrationCity;
this.model.m_token = this.$route.query.token;
this.model.documentTypeid=this.model.documentTypeid.toString();
this.value2.push(res.body.company.registrationProvince.toString());
this.value2.push(res.body.company.registrationCity.toString());
var nimg1 =document.getElementById("imgs1")
var nimg2 =document.getElementById("imgs2")
var nimg3 =document.getElementById("imgs3")
nimg1.src=this.image1
nimg2.src=this.image2
nimg3.src=this.image3
},function(res){
console.log(res.status);
});
}



},function(res){
console.log(res.status);
});

this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getArea',this.model,{emulateJSON:true}).then(function(res){
this.list2 = res.body.list
},function(res){
console.log(res.status);
});
},
methods: {
goBack(){
if(this.fromUrl){
this.$router.push({
path : '/user/index',
query : {}
})
}else{
this.$router.push({
path : '/learn/tryout',
query : {}
})
}

},
onChangeValue2(val){
this.model.registrationProvince=this.value2[0]
this.model.registrationCity=this.value2[1]
},

fileClick(index){
document.getElementById('img'+index).click()
this.imgIndex=index;
},
uploadIMG(e) {
let files = e.target.files || e.dataTransfer.files;
if (!files.length) return;
this.picavalue = files[0];
this.imgSize=this.picavalue.size / 1024;

if (this.picavalue.size / 1024 > 8000) {
this.$message({
message: "图片过大不支持上传",
type: "warning"
});
} else {
this.imgPreview(this.picavalue);
}
},

newCommit(){
this.model={};
this.model.m_token=this.$route.query.token
this.show_div1=1
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getCompanyCert',this.model,{emulateJSON:true}).then(function(res){
this.model = res.body.company;
this.model.registrationProvince = res.body.company.registrationProvince;
this.model.registrationCity = res.body.company.registrationCity;
this.model.m_token = this.$route.query.token;
this.model.documentTypeid=this.model.documentTypeid.toString();
this.value2.push(res.body.company.registrationProvince.toString());
this.value2.push(res.body.company.registrationCity.toString());
var nimg1 =document.getElementById("imgs1")
var nimg2 =document.getElementById("imgs2")
var nimg3 =document.getElementById("imgs3")
nimg1.src=this.image1
nimg2.src=this.image2
nimg3.src=this.image3
},function(res){
console.log(res.status);
});
},

imgPreview(file, callback) {
let self = this;

if (!file || !window.FileReader) return;
if (/^image/.test(file.type)) {

let reader = new FileReader();


reader.readAsDataURL(file);

reader.onloadend = function() {
let result = this.result;
let img = new Image();
img.src = result;

img.onload = function() {
let data;

if(self.imgSize>500){
data = self.compress(img);
}else{
data = result;
}

self.imgUrl = result;

var imgs =document.getElementById("imgs"+self.imgIndex);
imgs.src=data

let blob = self.dataURItoBlob(data);

var formData = new FormData();
formData.append("file", blob);
formData.append("imgType", file.name);
self.addImag(self.imgIndex,formData)
};
};
}
},

addImag(index,formData){
let config = {
headers: { "Content-Type": "multipart/form-data" }
};
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/addImage',formData,config,{emulateJSON:true}).then(function(res){
if(index==1){
this.model.businessLicensePic = res.body.src
this.show=false
}else if(index==2){
this.model.businessEntityPicA = res.body.src
this.showA=false
}else if(index==3){
this.model.businessEntityPicB = res.body.src
this.showB=false
}
},function(res){
console.log(res.status);
});
},

compress(img) {
let canvas = document.createElement("canvas");
let ctx = canvas.getContext("2d");
let initSize = img.src.length;
let width = img.width;
let height = img.height;
canvas.width = width;
canvas.height = height;

ctx.fillStyle = "#fff";
ctx.fillRect(0, 0, canvas.width, canvas.height);
ctx.drawImage(img, 0, 0, width, height);


let ndata = canvas.toDataURL("image/jpeg", 0.5);



return ndata;
},

dataURItoBlob(base64Data) {
var byteString;
if (base64Data.split(",")[0].indexOf("base64") >= 0)
byteString = atob(base64Data.split(",")[1]);
else byteString = unescape(base64Data.split(",")[1]);
var mimeString = base64Data
.split(",")[0]
.split(":")[1]
.split(";")[0];
var ia = new Uint8Array(byteString.length);
for (var i = 0; i < byteString.length; i++) {
ia[i] = byteString.charCodeAt(i);
}
return new Blob([ia], { type: mimeString });
},

delImg() {
this.imgUrl = null;
},

addCompanyCert(){
let that =this;
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/addCompanyCert',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.$vux.alert.show({
title: '提示',
content: '提交成功',
onHide () {
that.$router.go(0);
}
})
}else{
this.$vux.alert.show({
title: '提示',
content: res.body.message,
})
}
},function(res){
console.log(res.status);
});
}
}
}






// WEBPACK FOOTER //
// ./src/views/user/cert1.vue